/*
    HOME (LP Zênite) — portado de zenite.html + obra.html (scripts inline originais)

    SUMMARY
        1 - LP Zênite (Lenis, cursor, plantas, vista 360°, galeria/lightbox, mapa, hero WebGL, form)
        2 - Exposição global p/ handlers inline (onclick=)
        3 - Seção Andamento da Obra (stories) — IIFE isolada (evita colisão de escopo c/ a LP)

    Obs: bibliotecas (gsap, ScrollTrigger, Lenis, three, leaflet) vêm por CDN no layout (app.blade.php).
    Tudo roda em DOMContentLoaded — os CDNs com defer já estão garantidos nesse momento.
*/
document.addEventListener('DOMContentLoaded', () => {
        gsap.registerPlugin(ScrollTrigger);

        // HERO: a URL do vídeo vem em data-src (não em <source>), então o preload
        // do browser NÃO baixa o vídeo durante o parse. Aqui decidimos por largura:
        //   ≤640px (mobile): remove o elemento e NÃO injeta a fonte → vídeo nunca é
        //     baixado (home mais leve, pedido do cliente). O fundo vira o poster
        //     (background-image no .hero__media, via CSS). revealHero() cai no else
        //     imediato (L~665) e o fade-in do hero segue via body.is-ready.
        //   >640px (desktop): injeta a <source> agora; heroVideo.load() (mais abaixo)
        //     dispara o download só nesse caso.
        const __heroVideoEl = document.getElementById('heroVideo');
        if (__heroVideoEl) {
            if (window.matchMedia('(max-width: 640px)').matches) {
                __heroVideoEl.remove();
            } else if (__heroVideoEl.dataset.src) {
                const __heroSource = document.createElement('source');
                __heroSource.src = __heroVideoEl.dataset.src;
                __heroSource.type = 'video/mp4';
                __heroVideoEl.appendChild(__heroSource);
            }
        }

        // Lenis Smooth Scroll
        const lenis = new Lenis({
            duration: 1.6,
            easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 0.8
        });
        let isScrolling;
        lenis.on('scroll', () => {
            ScrollTrigger.update();
            document.body.classList.add('is-scrolling');
            clearTimeout(isScrolling);
            isScrolling = setTimeout(() => {
                document.body.classList.remove('is-scrolling');
            }, 150);
        });
        gsap.ticker.add(time => {
            lenis.raf(time * 1000);
        });
        gsap.ticker.lagSmoothing(0);
        // expõe p/ módulos do main.js (privacy_modal.js usa stop/start no scroll lock)
        window.lenis = lenis;

        // Âncoras internas via Lenis: o pulo nativo do navegador briga com o smooth
        // scroll (o Lenis guarda a posição interna e "volta" no próximo wheel/frame).
        // Intercepta cliques em links #hash e anima com lenis.scrollTo.
        document.querySelectorAll('a[href^="#"]').forEach(link => {
            link.addEventListener('click', e => {
                const hash = link.getAttribute('href');
                e.preventDefault();
                if (hash.length <= 1) {
                    lenis.scrollTo(0);
                    return;
                }
                const target = document.querySelector(hash);
                if (target) {
                    lenis.scrollTo(target);
                    history.pushState(null, '', hash);
                }
            });
        });

        // Custom Cursor — skip on mobile/touch
        const cursor = document.querySelector('.cursor');
        const dot = document.querySelector('.cursor-dot');
        let mouseX = 0, mouseY = 0;
        let cursorX = 0, cursorY = 0;
        let dotX = 0, dotY = 0;
        let cursorNeedsUpdate = false;

        if (cursor && dot && window.matchMedia('(pointer: fine)').matches) {
            window.addEventListener('mousemove', e => {
                mouseX = e.clientX;
                mouseY = e.clientY;
                cursorNeedsUpdate = true;
            }, { passive: true });

            gsap.ticker.add(() => {
                if (!cursorNeedsUpdate) return;
                // Outer cursor lerp (slower, floating feel)
                cursorX += (mouseX - cursorX) * 0.15;
                cursorY += (mouseY - cursorY) * 0.15;
                gsap.set(cursor, { x: cursorX, y: cursorY });

                // Inner dot lerp (faster, responsive feel)
                dotX += (mouseX - dotX) * 0.35;
                dotY += (mouseY - dotY) * 0.35;
                gsap.set(dot, { x: dotX, y: dotY });

                // Sleep the ticker callback when cursor has finished moving
                if (Math.abs(mouseX - cursorX) < 0.2 && Math.abs(mouseY - cursorY) < 0.2 &&
                    Math.abs(mouseX - dotX) < 0.2 && Math.abs(mouseY - dotY) < 0.2) {
                    cursorNeedsUpdate = false;
                }
            });

            // Cursor Hover classes
            document.querySelectorAll('a, button, input, select, textarea, .btn-outline, .btn-ink, .partner-cell, .plant-card, .bento__cell').forEach(el => {
                el.addEventListener('mouseenter', () => cursor.classList.add('is-hover'), { passive: true });
                el.addEventListener('mouseleave', () => cursor.classList.remove('is-hover'), { passive: true });
            });
        }

        // Plant tabs system
        const plantTabs = document.querySelectorAll('.plant-tab');
        const plantPanels = document.querySelectorAll('.plant-panel');

        plantTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const plantIdx = tab.dataset.plant;

                // Update tabs
                plantTabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                // Update panels
                plantPanels.forEach(p => p.classList.remove('active'));
                const targetPanel = document.querySelector('.plant-panel[data-plant="' + plantIdx + '"]');
                if (targetPanel) {
                    targetPanel.classList.add('active');
                    // Reset slides
                    const slides = targetPanel.querySelectorAll('.plant-slide');
                    const dots = targetPanel.querySelectorAll('.slide-dots button');
                    slides.forEach((s, i) => {
                        if (i === 0) { s.classList.remove('opacity-0', 'z-0'); s.classList.add('opacity-100', 'z-10'); }
                        else { s.classList.remove('opacity-100', 'z-10'); s.classList.add('opacity-0', 'z-0'); }
                    });
                    dots.forEach((d, i) => {
                        if (i === 0) { d.classList.add('bg-white'); d.classList.remove('bg-white/40'); }
                        else { d.classList.add('bg-white/40'); d.classList.remove('bg-white'); }
                    });
                }

                // Mobile: scroll tab into view
                if (window.innerWidth <= 980) {
                    tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }
            });
        });

        // ─── Availability Indicator ───
        // CMS-editable: update this object to reflect current unit availability
        const DISPONIBILIDADE = window.disponibilidade;

        function renderAvailability() {
            // ─── Image-corner tags on each plant panel ───
            document.querySelectorAll('.plant-panel[data-plant]').forEach(panel => {
                const key = panel.dataset.plant;
                const d = DISPONIBILIDADE[key];
                if (!d) return;

                // Avoid re-rendering
                if (panel.querySelector('.avail-tag')) return;

                const isLast = d.disponiveis === 1;
                const isSoldOut = d.disponiveis === 0;
                const ratio = d.disponiveis / d.total;

                // Determine variant
                let variant, label;
                if (isSoldOut) {
                    variant = 'gone';
                    label = 'Esgotado';
                } else if (isLast) {
                    variant = 'hot';
                    label = 'Última unidade';
                } else if (ratio <= 0.35) {
                    variant = 'low';
                    label = d.disponiveis + ' unidades disponíveis';
                } else {
                    variant = 'ok';
                    label = d.disponiveis + ' unidades disponíveis';
                }

                const tag = document.createElement('div');
                tag.className = 'avail-tag avail-tag--' + variant;
                tag.innerHTML = '<span class="avail-tag__dot"></span>' + label;

                // Insert into the media container (over the image)
                const media = panel.querySelector('.plant-panel__media');
                if (media) {
                    media.appendChild(tag);
                }

                // Handle sold-out CTA
                const info = panel.querySelector('.plant-panel__info');
                if (info) {
                    const btn = info.querySelector('.btn-ghost');
                    if (isSoldOut && btn) {
                        btn.classList.add('is-sold-out');
                        btn.textContent = 'Esgotado';
                        btn.removeAttribute('onclick');
                    }
                }
            });

            // ─── Tab-level colored dots ───
            document.querySelectorAll('.plant-tab[data-plant]').forEach(tab => {
                const key = tab.dataset.plant;
                const d = DISPONIBILIDADE[key];
                if (!d) return;

                if (tab.querySelector('.plant-tab__avail')) return;

                const dot = document.createElement('span');
                dot.className = 'plant-tab__avail';

                const ratio = d.disponiveis / d.total;
                if (d.disponiveis === 0) {
                    dot.classList.add('plant-tab__avail--gone');
                } else if (d.disponiveis === 1) {
                    dot.classList.add('plant-tab__avail--hot');
                } else if (ratio <= 0.35) {
                    dot.classList.add('plant-tab__avail--low');
                } else {
                    dot.classList.add('plant-tab__avail--ok');
                }

                const areaEl = tab.querySelector('.plant-tab__area');
                if (areaEl) {
                    areaEl.appendChild(dot);
                } else {
                    tab.appendChild(dot);
                }
            });
        }

        // Run after DOM is settled
        renderAvailability();

        // Plant slide galleries
        document.querySelectorAll('.group\\/gal').forEach(gallery => {
            const slides = gallery.querySelectorAll('.plant-slide');
            const dots = gallery.querySelectorAll('.slide-dots button');
            const prevBtn = gallery.querySelector('.prev-slide-btn');
            const nextBtn = gallery.querySelector('.next-slide-btn');
            let currentIdx = 0;

            function showSlide(index) {
                currentIdx = (index + slides.length) % slides.length;
                slides.forEach((slide, idx) => {
                    if (idx === currentIdx) {
                        slide.classList.remove('opacity-0', 'z-0');
                        slide.classList.add('opacity-100', 'z-10');
                    } else {
                        slide.classList.remove('opacity-100', 'z-10');
                        slide.classList.add('opacity-0', 'z-0');
                    }
                });
                dots.forEach((dot, idx) => {
                    if (idx === currentIdx) {
                        dot.classList.add('bg-white');
                        dot.classList.remove('bg-white/40');
                    } else {
                        dot.classList.add('bg-white/40');
                        dot.classList.remove('bg-white');
                    }
                });
            }

            if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); showSlide(currentIdx - 1); });
            if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); showSlide(currentIdx + 1); });
            dots.forEach((dot, idx) => { dot.addEventListener('click', (e) => { e.stopPropagation(); showSlide(idx); }); });
        });

        // Nav scroll — throttled with rAF for performance
        const nav = document.querySelector('nav.top');
        const burger = document.getElementById('navBurger');
        let navScrollTicking = false;
        window.addEventListener('scroll', () => {
            if (navScrollTicking) return;
            navScrollTicking = true;
            requestAnimationFrame(() => {
                const scrolled = window.scrollY > 80;
                nav.classList.toggle('scrolled', scrolled);
                if (burger) burger.classList.toggle('scrolled', scrolled);
                navScrollTicking = false;
            });
        }, { passive: true });

        // Menu mobile (hamburger) — overlay no header.blade.php, estilos no layout/header.scss
        const mobileMenu = document.getElementById('mobileMenu');
        if (burger && mobileMenu) {
            // habilita a exibição do burger (≤980px) — ver layout/header.scss
            document.body.classList.add('has-mobile-menu');
            const setMenuOpen = (open) => {
                document.body.classList.toggle('menu-open', open);
                burger.setAttribute('aria-expanded', String(open));
                burger.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
                mobileMenu.setAttribute('aria-hidden', String(!open));
                // trava o scroll de fundo enquanto o overlay está aberto
                if (open) lenis.stop(); else lenis.start();
            };

            burger.addEventListener('click', () => {
                setMenuOpen(!document.body.classList.contains('menu-open'));
            });

            // Captura no container: fecha (e religa o Lenis) ANTES do handler global
            // de âncoras acima disparar o lenis.scrollTo no próprio link.
            mobileMenu.addEventListener('click', e => {
                if (e.target.closest('a[href^="#"]')) setMenuOpen(false);
            }, true);

            document.addEventListener('keydown', e => {
                if (e.key === 'Escape' && document.body.classList.contains('menu-open')) setMenuOpen(false);
            });
        }

        // Dropdown "Mais" do menu desktop (hero) — hover/focus abrem via CSS;
        // o clique alterna .is-open p/ telas touch >980px (tablet landscape) e aria.
        const menuMore = document.querySelector('.hero__menu-more');
        if (menuMore) {
            const moreBtn = menuMore.querySelector('button');
            const setMoreOpen = (open) => {
                menuMore.classList.toggle('is-open', open);
                moreBtn.setAttribute('aria-expanded', String(open));
            };

            moreBtn.addEventListener('click', () => {
                setMoreOpen(!menuMore.classList.contains('is-open'));
            });

            // clique fora ou em um link do submenu fecha
            document.addEventListener('click', e => {
                if (!menuMore.contains(e.target) || e.target.closest('.hero__submenu a')) {
                    if (menuMore.classList.contains('is-open')) setMoreOpen(false);
                }
            });

            document.addEventListener('keydown', e => {
                if (e.key === 'Escape' && menuMore.classList.contains('is-open')) setMoreOpen(false);
            });
        }

        // GSAP Parallax Hero Media
        gsap.to('.hero__media video', {
            yPercent: 12,
            scale: 1.1,
            ease: 'none',
            scrollTrigger: {
                trigger: '.hero',
                start: 'top top',
                end: 'bottom top',
                scrub: 1
            }
        });

        // Pause/play hero video when off-screen to save CPU/GPU resources
        const heroVideoElement = document.getElementById("heroVideo");
        if (heroVideoElement) {
            ScrollTrigger.create({
                trigger: '.hero',
                start: 'top bottom',
                end: 'bottom top',
                onEnter: () => { if (document.body.classList.contains('is-ready')) heroVideoElement.play().catch(() => {}); },
                onEnterBack: () => { if (document.body.classList.contains('is-ready')) heroVideoElement.play().catch(() => {}); },
                onLeave: () => { heroVideoElement.pause(); },
                onLeaveBack: () => { heroVideoElement.pause(); }
            });
        }

        // GSAP reveal animations
        gsap.utils.toArray('.reveal').forEach(el => {
            let delay = 0;
            if (el.classList.contains('reveal-delay-1')) delay = 0.12;
            else if (el.classList.contains('reveal-delay-2')) delay = 0.24;
            else if (el.classList.contains('reveal-delay-3')) delay = 0.36;
            else if (el.classList.contains('reveal-delay-4')) delay = 0.48;

            let duration = el.classList.contains('reveal-slow') ? 1.4 : 0.8;

            gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: duration,
                delay: delay,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 95%'
                }
            });
        });

        // GSAP Layered Visual Stack Parallax (Conceito)
        // Desktop only: on mobile the stack is single-column and the downward
        // yPercent shift on .large would push the image over the paragraph below.
        ScrollTrigger.matchMedia({
            "(min-width: 901px)": function () {
                gsap.utils.toArray('.layer').forEach(layer => {
                    const speed = parseFloat(layer.dataset.speed || 0.1);
                    gsap.to(layer, {
                        yPercent: speed * 100,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: '.visual-stack',
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: 1.2
                        }
                    });
                });
            }
        });

        // GSAP Clip-Path Expansion Animation with pinning on desktop
        ScrollTrigger.matchMedia({
            // Desktop only (above 768px)
            "(min-width: 769px)": function () {
                gsap.fromTo('.expansion',
                    { scale: 0.8, clipPath: 'inset(10% 12% round 0px)' },
                    {
                        scale: 1,
                        clipPath: 'inset(0% 0% round 0px)',
                        ease: 'none',
                        scrollTrigger: {
                            trigger: '.split-feature-row',
                            start: 'center center',
                            end: '+=80%',
                            scrub: 1.2,
                            pin: true,
                            anticipatePin: 1
                        }
                    }
                );
            },
            // Mobile/tablet (no pinning to prevent jumping or weird layout issues)
            "(max-width: 768px)": function () {
                gsap.fromTo('.expansion',
                    { scale: 0.8, clipPath: 'inset(10% 12% round 0px)' },
                    {
                        scale: 1,
                        clipPath: 'inset(0% 0% round 0px)',
                        ease: 'none',
                        scrollTrigger: {
                            trigger: '.expansion',
                            start: 'top bottom',
                            end: 'bottom center',
                            scrub: 1.2
                        }
                    }
                );
            }
        });

        // Pinned Concept Gallery Title & Image (Desktop only)
        ScrollTrigger.matchMedia({
            "(min-width: 901px)": function () {
                // Scroll cue do Conceito: a barra preenche conforme o pin avança
                // (QA: a seção parecia travada) e some perto do fim.
                const conceptScrollFill = document.querySelector('.concept-scroll-cue__fill');
                const conceptScrollCue = document.querySelector('.concept-scroll-cue');
                gsap.to('.concept-gallery-pin', {
                    scrollTrigger: {
                        trigger: '.concept-gallery',
                        start: 'top top',
                        end: 'bottom bottom',
                        pin: '.concept-gallery-pin',
                        scrub: 1.2,
                        onUpdate: self => {
                            if (conceptScrollFill) conceptScrollFill.style.width = (self.progress * 100) + '%';
                            if (conceptScrollCue) conceptScrollCue.style.opacity = self.progress > 0.92 ? '0' : '1';
                        }
                    }
                });

                gsap.to('.concept-gallery-frame', {
                    clipPath: 'inset(0% 0% round 0px)',
                    scale: 1.01,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '.concept-gallery',
                        start: 'top top',
                        end: '70% bottom',
                        scrub: 1.5
                    }
                });

                gsap.to('.concept-gallery-frame img', {
                    scale: 1,
                    yPercent: 0,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '.concept-gallery',
                        start: 'top top',
                        end: 'bottom bottom',
                        scrub: 1.5
                    }
                });
            }
        });

        // Form submission
        // const form = document.getElementById('leadForm');
        // const toast = document.getElementById('toast');
        // form.addEventListener('submit', (e) => {
        //     e.preventDefault();
        //     const data = Object.fromEntries(new FormData(form));
        //     console.log('Lead:', data);
        //     toast.style.display = 'block';
        //     form.reset();
        //     setTimeout(() => {
        //         toast.style.display = 'none';
        //     }, 4000);
        // });

        // ─── Vista 360° Tours ───
        const TOUR_URLS = window.TOUR_URLS;

        const TOUR_FLOOR_NAMES = window.TOUR_FLOOR_NAMES;

        let currentTourKey = '8';
        let modalGyroActive = false;

        function open360Tour(key) {
            const modal = document.getElementById('tourModal');
            const modalIframe = document.getElementById('tourModalIframe');
            const info = TOUR_FLOOR_NAMES[key];
            if (!info) return;

            currentTourKey = key;
            document.getElementById('tourModalTitle').textContent = 'Vista 360°';
            document.getElementById('tourModalSubtitle').textContent = info.name + ' — ' + info.detail;

            // Reset modal gyro state when opening
            modalGyroActive = false;
            const btn = document.getElementById('tourModalGyroBtn');
            const label = document.getElementById('tourModalGyroLabel');
            if (btn) btn.classList.remove('is-active');
            if (label) label.textContent = 'Giroscópio';

            const url = TOUR_URLS[key];
            modalIframe.src = url;
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            if (typeof lenis !== 'undefined') lenis.stop();
        }

        function toggleModalGyro() {
            modalGyroActive = !modalGyroActive;
            const btn = document.getElementById('tourModalGyroBtn');
            const label = document.getElementById('tourModalGyroLabel');
            btn.classList.toggle('is-active', modalGyroActive);
            label.textContent = modalGyroActive ? 'Giroscópio ativo' : 'Giroscópio';

            const modalIframe = document.getElementById('tourModalIframe');
            const url = TOUR_URLS[currentTourKey];
            modalIframe.src = modalGyroActive
                ? url + (url.includes('?') ? '&' : '?') + 'gyroscope=true'
                : url;
        }

        function closeTour() {
            const modal = document.getElementById('tourModal');
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
            if (typeof lenis !== 'undefined') lenis.start();
            setTimeout(() => { document.getElementById('tourModalIframe').src = ''; }, 500);
        }

        document.getElementById('tourModalClose').addEventListener('click', closeTour);
        document.getElementById('tourModal').addEventListener('click', function (e) {
            if (e.target === this) closeTour();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeTour();
        });

        // ─── Vista 360° Interaction (Grid Rows) ───
        document.querySelectorAll('.floor-row').forEach(row => {
            row.addEventListener('click', () => {
                open360Tour(row.dataset.floor);
            });
        });

        function openForm() {
            lenis.scrollTo('#contato');
        }

        // Preloader and WebGL Banner script from hero banner.html
        const body = document.body;
        const preloader = document.getElementById("preloader");
        const progressBar = document.getElementById("preloaderProgress");
        const progressText = document.getElementById("preloaderPercent");
        const heroVideo = document.getElementById("heroVideo");

        let revealed = false;
        let fakeProgress = 0;

        function setProgress(value) {
            const safeValue = Math.max(0, Math.min(100, Math.round(value)));
            if (progressBar) progressBar.style.width = `${safeValue}%`;
            if (progressText) progressText.textContent = `${safeValue}%`;
        }

        function revealHero() {
            if (revealed) return;
            revealed = true;

            setProgress(100);

            if (heroVideo) {
                heroVideo.play().catch(() => { });
            }

            requestAnimationFrame(() => {
                body.classList.remove("is-loading");
                body.classList.add("is-ready");
                if (preloader) preloader.classList.add("is-hidden");

                window.setTimeout(() => {
                    try {
                        initWebGLTitleInteraction();
                    } catch (error) {
                        console.warn("WebGL desativado por segurança:", error);
                        body.classList.remove("webgl-title-ready");
                    }
                }, 120);
            });
        }

        if (heroVideo) {
            const progressTimer = window.setInterval(() => {
                if (revealed) {
                    window.clearInterval(progressTimer);
                    return;
                }

                if (heroVideo.duration && heroVideo.buffered.length) {
                    const bufferedEnd = heroVideo.buffered.end(heroVideo.buffered.length - 1);
                    const percent = (bufferedEnd / heroVideo.duration) * 100;
                    setProgress(percent);

                    if (percent >= 80) revealHero();
                    return;
                }

                fakeProgress = Math.min(fakeProgress + 5, 92);
                setProgress(fakeProgress);
            }, 180);

            heroVideo.addEventListener("loadeddata", revealHero, { once: true });
            heroVideo.addEventListener("canplay", revealHero, { once: true });
            heroVideo.addEventListener("canplaythrough", revealHero, { once: true });

            heroVideo.addEventListener("error", () => {
                console.warn("Vídeo não confirmou carregamento. Liberando hero para evitar travamento.");
                revealHero();
            }, { once: true });

            window.setTimeout(revealHero, 3500);

            window.addEventListener("load", () => {
                window.setTimeout(revealHero, 800);
            });

            heroVideo.load();
        } else {
            revealHero();
        }

        const buildingEl = document.querySelector('.hero__building');
        if (buildingEl) {
            gsap.set(buildingEl, { opacity: 0, y: 18 });

            const observer = new MutationObserver(() => {
                if (document.body.classList.contains('is-ready')) {
                    observer.disconnect();
                    gsap.to(buildingEl, {
                        opacity: 1,
                        y: 0,
                        duration: 1.8,
                        delay: 0.5,
                        ease: 'power3.out'
                    });
                }
            });
            observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        }

        function initWebGLTitleInteraction() {
            const hero = document.querySelector(".hero");
            const mount = document.getElementById("webglTitle");
            const title = document.querySelector(".hero__title");

            if (!hero || !mount || !title || !window.THREE || window.matchMedia("(max-width: 640px)").matches) return;
            if (mount.dataset.initialized === "true") return;
            mount.dataset.initialized = "true";

            const renderer = new THREE.WebGLRenderer({
                alpha: true,
                antialias: true,
                powerPreference: "high-performance"
            });

            renderer.setSize(hero.clientWidth, hero.clientHeight);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
            mount.appendChild(renderer.domElement);

            const scene = new THREE.Scene();
            const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
            const geometry = new THREE.PlaneGeometry(2, 2, 96, 96);

            const textCanvas = document.createElement("canvas");
            const textCtx = textCanvas.getContext("2d", { willReadFrequently: false });
            const maskTexture = new THREE.CanvasTexture(textCanvas);
            maskTexture.minFilter = THREE.LinearFilter;
            maskTexture.magFilter = THREE.LinearFilter;

            const uniforms = {
                uMask: { value: maskTexture },
                uTime: { value: 0 },
                uMouse: { value: new THREE.Vector2(0.5, 0.5) },
                uAspect: { value: 1 },
                uStrength: { value: 0 }
            };

            const material = new THREE.ShaderMaterial({
                transparent: true,
                depthTest: false,
                depthWrite: false,
                uniforms,
                vertexShader: `
        varying vec2 vUv;

        void main() {
          vUv = uv;
          gl_Position = vec4(position.xy, 0.0, 1.0);
        }
      `,
                fragmentShader: `
        uniform sampler2D uMask;
        uniform float uTime;
        uniform vec2 uMouse;
        uniform float uAspect;
        uniform float uStrength;
        varying vec2 vUv;

        float organicWave(vec2 p, vec2 center) {
          vec2 d = p - center;
          d.x *= uAspect;

          float dist = length(d);
          float waveA = sin(dist * 18.0 - uTime * 2.4);
          float waveB = sin((p.x * 6.0 + p.y * 3.2) + uTime * 0.72) * 0.28;
          float falloff = exp(-dist * 4.6);

          return (waveA + waveB) * falloff;
        }

        void main() {
          vec2 uv = vUv;
          float wave = organicWave(uv, uMouse);

          vec2 maskUv = uv;
          maskUv.x += wave * 0.014 * uStrength;
          maskUv.y += wave * 0.010 * uStrength;

          float alpha = texture2D(uMask, maskUv).a;

          if (alpha < 0.01) discard;

          vec3 originalColor = texture2D(uMask, maskUv).rgb;
          float sheen = abs(wave) * uStrength;

          vec3 color = originalColor;
          color += vec3(0.035, 0.028, 0.018) * sheen;

          gl_FragColor = vec4(color, alpha * 0.96);
        }
      `
            });

            scene.add(new THREE.Mesh(geometry, material));

            let targetX = 0.5;
            let targetY = 0.5;
            let currentX = 0.5;
            let currentY = 0.5;
            let targetStrength = 0.12;
            let currentStrength = 0;

            function drawSpacedText(ctx, text, x, y, spacing) {
                let currentX = x;

                for (const char of text) {
                    ctx.fillText(char, currentX, y);
                    currentX += ctx.measureText(char).width + spacing;
                }
            }

            function drawTextMask() {
                const rect = mount.getBoundingClientRect();
                const titleRect = title.getBoundingClientRect();
                const dpr = Math.min(window.devicePixelRatio, 1.5);

                textCanvas.width = Math.max(1, Math.floor(rect.width * dpr));
                textCanvas.height = Math.max(1, Math.floor(rect.height * dpr));

                textCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
                textCtx.clearRect(0, 0, rect.width, rect.height);
                textCtx.textBaseline = "top";
                textCtx.textAlign = "left";

                const computed = window.getComputedStyle(title);
                const fontSize = parseFloat(computed.fontSize);
                const lineHeight = fontSize * 0.78;
                const letterSpacing = fontSize * -0.065;
                const fontWeight = computed.fontWeight || "400";
                const startX = titleRect.left - rect.left;
                const startY = titleRect.top - rect.top;

                const lines = [
                    {
                        indent: 0,
                        segments: [
                            { text: "O ponto", italic: false }
                        ]
                    },
                    {
                        indent: window.innerWidth * 0.08,
                        segments: [
                            { text: "alto de", italic: false }
                        ]
                    },
                    {
                        indent: 0,
                        segments: [
                            { text: "morar em", italic: false }
                        ]
                    },
                    {
                        indent: window.innerWidth * 0.03,
                        segments: [
                            { text: "Florianópolis.", italic: true }
                        ]
                    }
                ];

                lines.forEach((line, index) => {
                    let currentX = startX + line.indent;
                    const y = startY + index * lineHeight;

                    line.segments.forEach(segment => {
                        textCtx.font = `${segment.italic ? "italic" : "normal"} ${fontWeight} ${fontSize}px "Playfair Display", Georgia, serif`;
                        textCtx.fillStyle = segment.italic ? "#d8d0c3" : "#faf8f4";
                        drawSpacedText(textCtx, segment.text, currentX, y, letterSpacing);
                        currentX += [...segment.text].reduce((acc, char) => acc + textCtx.measureText(char).width + letterSpacing, 0);
                    });
                });

                maskTexture.needsUpdate = true;
            }

            function resize() {
                const rect = mount.getBoundingClientRect();
                renderer.setSize(rect.width, rect.height, false);
                uniforms.uAspect.value = rect.width / Math.max(rect.height, 1);
                drawTextMask();
            }

            hero.addEventListener("mousemove", (event) => {
                const rect = hero.getBoundingClientRect();
                targetX = (event.clientX - rect.left) / rect.width;
                targetY = 1 - ((event.clientY - rect.top) / rect.height);
                targetStrength = 0.62;
            }, { passive: true });

            hero.addEventListener("mouseleave", () => {
                targetX = 0.5;
                targetY = 0.5;
                targetStrength = 0.12;
            });

            window.addEventListener("resize", resize);
            resize();
            body.classList.add("webgl-title-ready");

            // Pause WebGL when hero is off-screen for performance
            let webglVisible = true;
            let webglRafId = null;
            const webglObserver = new IntersectionObserver(([entry]) => {
                webglVisible = entry.isIntersecting;
                if (webglVisible && !webglRafId) {
                    webglRafId = requestAnimationFrame(animate);
                }
            }, { threshold: 0 });
            webglObserver.observe(hero);

            function animate(time) {
                if (!webglVisible) {
                    webglRafId = null;
                    return;
                }
                currentX += (targetX - currentX) * 0.04;
                currentY += (targetY - currentY) * 0.04;
                currentStrength += (targetStrength - currentStrength) * 0.032;
                targetStrength += (0.12 - targetStrength) * 0.01;

                uniforms.uTime.value = time * 0.001;
                uniforms.uMouse.value.set(currentX, currentY);
                uniforms.uStrength.value = currentStrength;

                renderer.render(scene, camera);
                webglRafId = requestAnimationFrame(animate);
            }

            webglRafId = requestAnimationFrame(animate);
        }

        // Leaflet Map Initialization
        let map;
        const markers = {};
        let mapInitialized = false;

        function initLeafletMap() {
            if (mapInitialized) return;
            mapInitialized = true;

            const mapCenter = [-27.595, -48.580]; // Center Capoeiras
            map = L.map('map', {
                center: mapCenter,
                zoom: 15,
                scrollWheelZoom: false,
                zoomControl: false
            });

            // Custom Zoom Control positioning
            L.control.zoom({
                position: 'bottomright'
            }).addTo(map);

            // CartoDB Positron Warm/Light map tiles
            L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; OpenStreetMap contributors &copy; CARTO'
            }).addTo(map);

            // Custom DivIcon generator based on reference type/name
            function getCustomIcon(name, isZenite, icon = null) {
                if (isZenite) {
                    return L.divIcon({
                        className: 'custom-pin-zenite',
                        html: `
              <div class="relative w-10 h-10 flex items-center justify-center">
                <span class="absolute animate-ping inline-flex h-full w-full rounded-full bg-[#1C1A17] opacity-25"></span>
                <div class="w-8 h-8 rounded-full bg-[#1C1A17] border-2 border-[#FAF8F4] flex items-center justify-center text-[#FAF8F4] shadow-lg">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4"><path d="M3 21h18M9 21V9a3 3 0 0 1 6 0v12M4 21V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16"/></svg>
                </div>
              </div>
            `,
                        iconSize: [40, 40],
                        iconAnchor: [20, 20],
                        popupAnchor: [0, -16]
                    });
                }

                let svgIcon = icon
                    ? `<img src="${icon}" class="w-3.5 h-3.5" alt="">`
                    : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-3.5 h-3.5"><circle cx="12" cy="12" r="3"/><path d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8z"/></svg>`;

                return L.divIcon({
                    className: 'custom-pin-other',
                    html: `
            <div class="w-8 h-8 rounded-full bg-[#FAF8F4] border border-[#8C8579] shadow-md flex items-center justify-center text-[#1C1A17] hover:bg-[#1C1A17] hover:text-[#FAF8F4] transition-colors duration-300">
              ${svgIcon}
            </div>
          `,
                    iconSize: [32, 32],
                    iconAnchor: [16, 16],
                    popupAnchor: [0, -12]
                });
            }

            // Main Site Marker
            const zeniteMarker = L.marker([-27.5950, -48.5830], {
                icon: getCustomIcon("Zênite", true),
                zIndexOffset: 1000
            })
                .addTo(map)
                .bindPopup(`
          <div class="p-1">
            <h4 class="font-serif font-bold text-sm text-[#1C1A17] mb-1">Zênite</h4>
            <p class="text-[11px] text-[#8C8579] leading-tight">O ponto alto de morar bem em Florianópolis.</p>
          </div>
        `)
                .bindTooltip("Zênite", {
                    permanent: true,
                    direction: 'top',
                    className: 'custom-tooltip zenite-tooltip',
                    offset: [0, -20]
                });

            const locations = window.locations;

            locations.forEach(loc => {
                const marker = L.marker([loc.lat, loc.lng], { icon: getCustomIcon(loc.name, false, loc.icon) })
                    .addTo(map)
                    .bindPopup(`
            <div class="p-1">
              <h4 class="font-serif font-bold text-xs text-[#1C1A17] mb-1">${loc.name}</h4>
              <p class="text-[11px] text-[#8C8579] leading-tight">${loc.desc}</p>
            </div>
          `)
                    .bindTooltip(loc.name, {
                        permanent: true,
                        direction: 'top',
                        className: 'custom-tooltip',
                        offset: [0, -16]
                    });
                markers[loc.lat + ',' + loc.lng] = marker;
            });
        }

        // Lazy load Leaflet Map when #localizacao approaches the viewport
        ScrollTrigger.create({
            trigger: '#localizacao',
            start: 'top bottom+=800',
            once: true,
            onEnter: () => {
                initLeafletMap();
            }
        });

        // O mapa é inicializado 800px antes de entrar na viewport e a seção usa
        // content-visibility:auto — nesse momento o #map ainda não tem a largura
        // final, então o Leaflet trava num tamanho menor e os tiles não preenchem
        // a coluna (mapa "encostado" na direita). Recalcula o tamanho quando a
        // seção realmente entra na viewport, já com a largura definitiva.
        ScrollTrigger.create({
            trigger: '#localizacao',
            start: 'top bottom',
            once: true,
            onEnter: () => {
                initLeafletMap();
                requestAnimationFrame(() => map && map.invalidateSize());
            }
        });

        // Interactive sidebar clicking
        document.querySelectorAll('.pin-item').forEach(item => {
            item.addEventListener('click', () => {
                initLeafletMap(); // ensure map is initialized

                const lat = parseFloat(item.dataset.lat);
                const lng = parseFloat(item.dataset.lng);

                map.flyTo([lat, lng], 16, {
                    animate: true,
                    duration: 1.5
                });

                const marker = markers[lat + ',' + lng];
                if (marker) {
                    setTimeout(() => {
                        marker.openPopup();
                    }, 1500);
                }
            });
        });

        // ─── Bento Grid Reveal Animation ───
        // Fade simples (opacity/y, compositor-friendly) no lugar do clip-path por célula:
        // animar clip-path repintava as 8 imagens (até 3840×4800) a cada frame, no mesmo
        // instante em que eram decodificadas (loading="lazy") — o main thread travava e,
        // como o scroll é dirigido por rAF (Lenis), a página parava de rolar.
        const cells = gsap.utils.toArray('.bento__cell');
        gsap.set(cells, { autoAlpha: 0, y: 32 });
        gsap.to(cells, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: 'power3.out',
            stagger: 0.07,
            scrollTrigger: {
                trigger: '#bento',
                start: 'top 80%',
                once: true,
            }
        });

        // ─── Bento Gallery / Lightbox Integration ───
        cells.forEach((cell) => {
            cell.addEventListener('click', () => {
                const idx = parseInt(cell.dataset.index, 10);
                openLightbox(idx);
            });
        });

        document.getElementById('openLightbox').addEventListener('click', () => openLightbox(0));

        // ─── Horizontal Draggable Lightbox ───
        const lightbox = document.getElementById('lightbox');
        const track = document.getElementById('lbTrack');
        const trackWrap = document.getElementById('lbTrackWrap');
        const progressEl = document.getElementById('lbProgress');
        const counterEl = document.getElementById('lbCounter');
        const slides = document.querySelectorAll('.lightbox__slide');
        const TOTAL = slides.length;

        let lbX = 0;        // current translateX
        let targetX = 0;    // target translateX (lerp)
        let isDragging = false;
        let startX = 0;
        let startLbX = 0;
        let rafId = null;
        let isOpen = false;

        function getMaxScroll() {
            return -(track.scrollWidth - trackWrap.clientWidth);
        }

        function clamp(v, min, max) {
            return Math.min(Math.max(v, min), max);
        }

        function updateProgress() {
            const max = getMaxScroll();
            const pct = max !== 0 ? (lbX / max) * 100 : 0;
            progressEl.style.width = pct.toFixed(2) + '%';

            // counter: which slide is most visible
            const ww = trackWrap.clientWidth;
            let closest = 0, minDist = Infinity;
            slides.forEach((s, i) => {
                const rect = s.getBoundingClientRect();
                const center = rect.left + rect.width / 2;
                const dist = Math.abs(center - ww / 2);
                if (dist < minDist) {
                    minDist = dist;
                    closest = i;
                }
            });
            counterEl.textContent = String(closest + 1).padStart(2, '0') + ' / ' + String(TOTAL).padStart(2, '0');
        }

        function lerp(a, b, t) {
            return a + (b - a) * t;
        }

        function rafLoop() {
            lbX = lerp(lbX, targetX, 0.09);
            gsap.set(track, { x: lbX });
            updateProgress();
            if (Math.abs(lbX - targetX) > 0.5) {
                rafId = requestAnimationFrame(rafLoop);
            } else {
                lbX = targetX;
                gsap.set(track, { x: lbX });
                updateProgress();
                rafId = null;
            }
        }

        function startRaf() {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(rafLoop);
        }

        function scrollToSlide(idx) {
            const slide = slides[idx];
            const wrapW = trackWrap.clientWidth;
            const slideL = slide.offsetLeft;
            const slideW = slide.offsetWidth;
            targetX = clamp(-(slideL - (wrapW - slideW) / 2), getMaxScroll(), 0);
            startRaf();
        }

        /* Wheel */
        trackWrap.addEventListener('wheel', (e) => {
            e.preventDefault();
            targetX = clamp(targetX - e.deltaY * 1.5, getMaxScroll(), 0);
            startRaf();
        }, { passive: false });

        /* Pointer drag */
        trackWrap.addEventListener('pointerdown', (e) => {
            isDragging = true;
            startX = e.clientX;
            startLbX = targetX;
            trackWrap.setPointerCapture(e.pointerId);
        });

        trackWrap.addEventListener('pointermove', (e) => {
            if (!isDragging) return;
            const dx = (e.clientX - startX) * 1.4;
            targetX = clamp(startLbX + dx, getMaxScroll(), 0);
            startRaf();
        });

        ['pointerup', 'pointercancel'].forEach(ev => {
            trackWrap.addEventListener(ev, () => { isDragging = false; });
        });

        /* Open */
        function openLightbox(startIdx = 0) {
            isOpen = true;
            lightbox.classList.add('is-open');
            lenis.stop();

            lbX = 0; targetX = 0;
            gsap.set(track, { x: 0 });

            gsap.to(lightbox, {
                opacity: 1,
                duration: 0.55,
                ease: 'expo.out',
                onComplete: () => {
                    scrollToSlide(startIdx);
                }
            });
        }

        /* Close */
        function closeLightbox() {
            isOpen = false;
            gsap.to(lightbox, {
                opacity: 0,
                duration: 0.4,
                ease: 'expo.in',
                onComplete: () => {
                    lightbox.classList.remove('is-open');
                    lenis.start();
                    if (rafId) {
                        cancelAnimationFrame(rafId);
                        rafId = null;
                    }
                }
            });
        }

        document.getElementById('closeLightbox').addEventListener('click', closeLightbox);
        document.addEventListener('keydown', (e) => {
            if (!isOpen) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowRight') {
                targetX = clamp(targetX - 500, getMaxScroll(), 0);
                startRaf();
            }
            if (e.key === 'ArrowLeft') {
                targetX = clamp(targetX + 500, getMaxScroll(), 0);
                startRaf();
            }
        });

        // ─── GLightbox (Plantas) ───
        // Zoom da planta baixa/perspectiva; lib via CDN no app.blade.php.
        // Lenis precisa parar com o overlay aberto (mesmo padrão do lightbox da galeria).
        if (typeof GLightbox !== 'undefined') {
            const plantasLightbox = GLightbox({
                selector: '.glightbox',
                touchNavigation: true,
                loop: false
            });
            plantasLightbox.on('open', () => lenis.stop());
            plantasLightbox.on('close', () => lenis.start());
        }

        /*---------------------/ 2 - Exposição global p/ handlers inline (onclick=) /-------------------*/
        window.openForm = openForm;
        window.toggleModalGyro = toggleModalGyro;

        /*---------------------/ 3 - SEÇÃO ANDAMENTO DA OBRA (portado de obra.html) /-------------------*/
        (() => {
            if (!document.getElementById('storyViewer')) return;

            const cursorEl = document.querySelector('.cursor');

        function bindCursorHovers() {
            if (!cursorEl || !window.matchMedia('(pointer: fine)').matches) return;
            document.querySelectorAll('.story-thumb, .story-tap, .play-pause-btn, .mute-btn, .seek-bar').forEach(el => {
                el.addEventListener('mouseenter', () => cursorEl.classList.add('is-hover'), { passive: true });
                el.addEventListener('mouseleave', () => cursorEl.classList.remove('is-hover'), { passive: true });
            });
        }

        // ═══ STORIES DATA ═══
        const stories = window.stories;

        // ═══ ENGINE ═══
        const TOTAL = stories.length;
        let currentIndex = 0;
        let isPaused = false;
        let isMuted = true;

        const viewer = document.getElementById('storyViewer');
        const video = document.getElementById('storyVideo');
        const progressContainer = document.getElementById('storyProgress');
        const storyNavWrap = document.getElementById('storyNavWrap');
        const storyNav = document.getElementById('storyNav');
        const titleEl = document.getElementById('storyTitle');
        const dateEl = document.getElementById('storyDate');

        const playPauseBtn = document.getElementById('playPauseBtn');
        const playIcon = document.getElementById('playIcon');
        const pauseIcon = document.getElementById('pauseIcon');
        const muteBtn = document.getElementById('muteBtn');
        const mutedIcon = document.getElementById('mutedIcon');
        const unmutedIcon = document.getElementById('unmutedIcon');
        const seekBar = document.getElementById('seekBar');
        const seekFill = document.getElementById('seekFill');
        const tapCenter = document.getElementById('tapCenter');


        // ─── Generate Thumbs ───
        function buildThumbs() {
            storyNav.innerHTML = '';
            stories.forEach((story, i) => {
                const thumb = document.createElement('div');
                thumb.className = 'story-thumb' + (i === 0 ? ' is-active' : '');
                thumb.dataset.index = i;
                thumb.innerHTML = `
          <div class="story-thumb__ring">
            <img class="story-thumb__img" src="${story.thumb}" alt="${story.label}" loading="lazy">
          </div>
          <span class="story-thumb__label">${story.label}</span>
        `;
                thumb.addEventListener('click', () => goTo(i));
                storyNav.appendChild(thumb);
            });
        }

        function scrollThumbIntoView(index) {
            const thumb = storyNav.children[index];
            if (!thumb) return;
            thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        function updateNavScrollState() {
            const el = storyNav;
            storyNavWrap.classList.toggle('can-scroll-left', el.scrollLeft > 2);
            storyNavWrap.classList.toggle('can-scroll-right', el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
        }

        // ─── Fit Viewer (uses more available space) ───
        function fitViewer() {
            const storiesCol = document.querySelector('.obra-stories');
            if (!storiesCol || !viewer) return;

            // ≤480px: o layout vira coluna única e o CSS já dimensiona o viewer
            // (width:100% + max-width:440px + aspect-ratio 9/16 + max-height:none).
            // O modelo de "fit por altura" abaixo só vale no layout desktop de 2
            // colunas — no celular ele derivava uma largura minúscula a partir da
            // altura da coluna (e o resize do iOS, disparado quando a barra de
            // endereço some ao rolar, reexecutava e encolhia o vídeo). Limpa os
            // estilos inline de uma eventual chamada anterior em largura desktop
            // e deixa o CSS no comando.
            if (window.matchMedia('(max-width: 480px)').matches) {
                viewer.style.width = '';
                viewer.style.maxHeight = '';
                return;
            }

            const colRect = storiesCol.getBoundingClientRect();
            const navH = storyNavWrap ? storyNavWrap.offsetHeight : 60;
            const gapH = 28;
            const paddingV = 32;
            const availH = Math.max(160, colRect.height - navH - gapH - paddingV);
            const widthFromH = availH * (9 / 16) * 0.88;
            const colW = colRect.width - 16;
            const cssMaxW = parseFloat(getComputedStyle(viewer).maxWidth) || 385;
            const finalW = Math.min(widthFromH, colW, cssMaxW);
            viewer.style.width = finalW + 'px';
            viewer.style.maxHeight = availH + 'px';
        }

        // ─── Progress ───
        function buildProgress() {
            progressContainer.innerHTML = '';
            for (let i = 0; i < TOTAL; i++) {
                const bar = document.createElement('div');
                bar.className = 'story-progress__bar' +
                    (i < currentIndex ? ' is-complete' : '') +
                    (i > currentIndex ? ' is-pending' : '');
                bar.innerHTML = '<div class="story-progress__fill"></div>';
                bar.addEventListener('click', () => goTo(i));
                progressContainer.appendChild(bar);
            }
        }

        function onTimeUpdate() {
            if (!video.duration || isPaused) return;
            const pct = (video.currentTime / video.duration) * 100;
            const bars = progressContainer.querySelectorAll('.story-progress__bar');
            const currentBar = bars[currentIndex];
            if (currentBar) {
                const fill = currentBar.querySelector('.story-progress__fill');
                if (fill) fill.style.width = pct + '%';
            }
            seekFill.style.width = pct + '%';
        }

        function onVideoEnded() {
            if (currentIndex < TOTAL - 1) goTo(currentIndex + 1);
        }

        video.addEventListener('timeupdate', onTimeUpdate);
        video.addEventListener('ended', onVideoEnded);

        // ─── Navigate ───
        function goTo(index) {
            if (index < 0) index = 0;
            if (index >= TOTAL) { isPaused = true; video.pause(); updatePlayPauseIcon(); return; }
            if (index === currentIndex && video.src) return;

            currentIndex = index;
            viewer.classList.add('is-transitioning');

            setTimeout(() => {
                const story = stories[currentIndex];
                video.src = story.video;
                video.muted = isMuted;
                video.load();
                video.play().catch(() => { });

                titleEl.textContent = story.title;
                dateEl.textContent = story.date;
                storyNav.querySelectorAll('.story-thumb').forEach((t, i) => {
                    t.classList.toggle('is-active', i === currentIndex);
                    t.classList.toggle('is-seen', i < currentIndex);
                });
                scrollThumbIntoView(currentIndex);

                isPaused = false;
                updatePlayPauseIcon();
                buildProgress();
                seekFill.style.width = '0%';
                viewer.classList.remove('is-transitioning');
            }, 280);
        }

        // ─── Play / Pause ───
        function togglePlayPause() {
            if (isPaused) { video.play().catch(() => { }); isPaused = false; }
            else { video.pause(); isPaused = true; }
            updatePlayPauseIcon();
            showPlayPauseFeedback();
        }

        function updatePlayPauseIcon() {
            playIcon.style.display = isPaused ? 'block' : 'none';
            pauseIcon.style.display = isPaused ? 'none' : 'block';
        }

        let ppTimer;
        function showPlayPauseFeedback() {
            playPauseBtn.classList.add('is-visible');
            clearTimeout(ppTimer);
            ppTimer = setTimeout(() => playPauseBtn.classList.remove('is-visible'), 1200);
        }

        function toggleMute() {
            isMuted = !isMuted;
            video.muted = isMuted;
            mutedIcon.style.display = isMuted ? 'block' : 'none';
            unmutedIcon.style.display = isMuted ? 'none' : 'block';
        }

        function onSeekClick(e) {
            if (!video.duration) return;
            const rect = seekBar.getBoundingClientRect();
            video.currentTime = ((e.clientX - rect.left) / rect.width) * video.duration;
        }

        // ─── Init ───
        function init() {
            buildThumbs();
            bindCursorHovers();

            const story = stories[0];
            video.src = story.video;
            video.muted = isMuted;
            video.load();
            titleEl.textContent = story.title;
            dateEl.textContent = story.date;

            buildProgress();
            updatePlayPauseIcon();
            fitViewer();

            ScrollTrigger.create({
                trigger: '.obra-section',
                start: 'top 60%',
                once: true,
                onEnter: () => video.play().catch(() => { })
            });
        }

        // ─── Events ───
        document.getElementById('navPrev').addEventListener('click', () => {
            storyNav.scrollBy({ left: -(storyNav.clientWidth * 0.8), behavior: 'smooth' });
        });
        document.getElementById('navNext').addEventListener('click', () => {
            storyNav.scrollBy({ left: storyNav.clientWidth * 0.8, behavior: 'smooth' });
        });

        document.getElementById('tapPrev').addEventListener('click', () => goTo(currentIndex - 1));
        document.getElementById('tapNext').addEventListener('click', () => goTo(currentIndex + 1));
        tapCenter.addEventListener('click', togglePlayPause);
        playPauseBtn.addEventListener('click', e => { e.stopPropagation(); togglePlayPause(); });
        muteBtn.addEventListener('click', e => { e.stopPropagation(); toggleMute(); });
        seekBar.addEventListener('click', e => { e.stopPropagation(); onSeekClick(e); });

        // Guarda de visibilidade: no obra.html standalone o teclado era global;
        // dentro da LP, setas/espaço só podem agir com a seção visível.
        let obraInView = false;
        const obraSectionEl = document.querySelector('.obra-section');
        if (obraSectionEl) {
            new IntersectionObserver(([entry]) => { obraInView = entry.isIntersecting; }, { threshold: 0.3 }).observe(obraSectionEl);
        }
        document.addEventListener('keydown', e => {
            if (!obraInView) return;
            if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
            if (e.key === 'ArrowRight') goTo(currentIndex + 1);
            if (e.key === ' ' || e.key === 'k') { e.preventDefault(); togglePlayPause(); }
            if (e.key === 'm') toggleMute();
        });
        let touchStartX = 0;
        viewer.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
        viewer.addEventListener('touchend', e => {
            const dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 50) { dx < 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1); }
        }, { passive: true });

        let wheelCooldown = false;
        document.querySelector('.obra-section').addEventListener('wheel', e => {
            const rect = viewer.getBoundingClientRect();
            const over = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
            if (over && !wheelCooldown) {
                e.preventDefault();
                wheelCooldown = true;
                setTimeout(() => { wheelCooldown = false; }, 800);
                e.deltaY > 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
            }
        }, { passive: false });

        storyNav.addEventListener('scroll', updateNavScrollState, { passive: true });
        window.addEventListener('resize', () => { fitViewer(); updateNavScrollState(); });

        init();
        })();
});
